function Footer(props) {
  const footerStyle = {
    color: "#0071BC",
    textTransform: "capitalize",
    fontSize: "14px",
    borderTop: "1px solid #000",
    paddingTop: "1rem",
  };
  return (
    <>
      <div className="main-footer" style={footerStyle}>
        <footer>
          {props?.heading.map((footer, index) => {
            return <p key={index}>{footer}</p>;
          })}
        </footer>
      </div>
    </>
  );
}
export default Footer;
